module.exports = __webpack_public_path__ + "img/thunderboar_kinetic_energy.68d726aa.png";